import { render, staticRenderFns } from "./CajasSubcliente.vue?vue&type=template&id=aadacb02&"
import script from "./CajasSubcliente.vue?vue&type=script&lang=js&"
export * from "./CajasSubcliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports